var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'btn-group',
    {
      fill: _vm.isFullWidth,
      'inline-flex': !_vm.isFullWidth,
      flex: _vm.isFullWidth,
      'w-full': _vm.isFullWidth,
    } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }